import NewButton from "components/common/controls/NewButton";

interface Props {
  displayNew?: boolean;
  newButtonText?: string;
  onNewClick?: () => void;
  filterComponent?: any;
}

export default function DataGridActionHeader(props: Props) {
  const {
    displayNew,
    newButtonText,
    filterComponent: FilterComponent,
    onNewClick,
  } = props;

  return (
    <>
      {displayNew && (
        <div className="inline float-left">
          <NewButton
            responsive={false}
            text={newButtonText || "New"}
            onClick={() => onNewClick?.()}
            key="grid-new-button"
          />
        </div>
      )}
      {FilterComponent && (
        <div className="inline float-right">
          <div>
            <FilterComponent />
          </div>
        </div>
      )}
    </>
  );
}
